<div [@dialog] *ngIf="visible" class="dialog">
   <button type="button" class="close-modal" (click)=" close();"><span>×</span></button>
  
   <ng-content></ng-content>
    
</div>
<div *ngIf="visible" class="overlay" (click)="close(); "></div>